import type { SVGProps } from "react";
export interface BandagesIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function BandagesIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: BandagesIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M19.056 14.031a1.126 1.126 0 0 1 1.506-.08l.085.079 1.413 1.406a3.62 3.62 0 0 1 0 5.128l-1.471 1.465a3.64 3.64 0 0 1-5.136 0l-1.402-1.397-.078-.085a1.125 1.125 0 0 1 1.58-1.587l.086.078 1.402 1.397a1.39 1.39 0 0 0 1.96 0l1.47-1.464a1.37 1.37 0 0 0 .094-1.837l-.093-.104-1.413-1.407-.077-.086a1.126 1.126 0 0 1 .075-1.506ZM3.687 1.721a3.64 3.64 0 0 1 4.86.25l1.407 1.4.077.087a1.126 1.126 0 0 1-1.579 1.585l-.086-.076-1.407-1.402a1.39 1.39 0 0 0-1.854-.095l-.106.095L3.53 5.03a1.37 1.37 0 0 0 0 1.94l1.415 1.411.078.085a1.126 1.126 0 0 1-1.58 1.587l-.086-.078-1.415-1.41a3.62 3.62 0 0 1 0-5.13l1.47-1.464zm11.764.219a3.633 3.633 0 0 1 5.14 0l1.47 1.47.249.274a3.635 3.635 0 0 1-.25 4.864L8.549 22.06a3.635 3.635 0 0 1-4.864.249l-.275-.25-1.47-1.47a3.633 3.633 0 0 1 0-5.139zM3.531 17.042c-.54.54-.54 1.417 0 1.957L5 20.47c.54.54 1.417.54 1.957 0l3.458-3.46-3.432-3.422zm5.043-5.045 3.432 3.422L15.426 12l-3.434-3.42zM19 3.531a1.384 1.384 0 0 0-1.957 0l-3.46 3.458 3.434 3.42 3.454-3.452c.54-.54.54-1.417 0-1.957L19 3.53Z"
      />
    </svg>
  );
}
